module.exports = __webpack_public_path__ + "img/239.bffd8baa.jpg";